export default "__VITE_ASSET__DiNbXxqW__"